import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { DASHBOARD_HERO_HEIGHT } from "web_myplann/Dashboard/Utils/dashboardLayout";

export const DashboardHeroSkeleton: FC = () => {
	const { spacingTokens, iconSize, radii } = useTheme();

	return (
		<Stack
			height={DASHBOARD_HERO_HEIGHT}
			px={spacingTokens.lg}
			pt={spacingTokens.sm}
			pb={spacingTokens.lg}
			alignItems="center"
		>
			<Stack
				direction="row"
				alignSelf="stretch"
				justifyContent="space-between"
				px={spacingTokens.sm}
				py={spacingTokens.sm}
			>
				<Skeleton
					variant="circular"
					width={iconSize.lg}
					height={iconSize.lg}
					animation="wave"
				/>
				<Stack direction="row" gap={spacingTokens.lg}>
					<Skeleton
						variant="circular"
						width={iconSize.lg}
						height={iconSize.lg}
						animation="wave"
					/>
					<Skeleton
						variant="circular"
						width={iconSize.lg}
						height={iconSize.lg}
						animation="wave"
					/>
				</Stack>
			</Stack>
			<Stack alignItems="center" gap={spacingTokens.sm} mt={spacingTokens.xl}>
				<Skeleton variant="rounded" width={120} height={16} animation="wave" />
				<Skeleton variant="rounded" width={220} height={36} animation="wave" />
				<Skeleton
					variant="rounded"
					width={88}
					height={24}
					animation="wave"
					sx={{ borderRadius: radii.full }}
				/>
			</Stack>
			<Stack alignItems="center" gap={spacingTokens.md} mt="auto">
				<Skeleton
					variant="rounded"
					width={72}
					height={32}
					animation="wave"
					sx={{ borderRadius: radii.full }}
				/>
				<Skeleton
					variant="rounded"
					width={96}
					height={8}
					animation="wave"
					sx={{ borderRadius: radii.full }}
				/>
			</Stack>
		</Stack>
	);
};
